module.exports = __webpack_public_path__ + "img/logo-coreinsi.aa6032b2.png";